import YesNoDescriptionInput from './YesNoDescriptionInput';
export default YesNoDescriptionInput;